import { c as _c } from "react/compiler-runtime";
import { Ban, Mail, ShieldCheck, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { OPERATOR } from "@/lib/operator";

// «Удаление аккаунта» - публичная инструкция для Google Play (веб-ссылка на
// удаление аккаунта и данных) и App Store: как удалить, что удаляется и что
// хранится. Само удаление - «Личные данные» → «Удалить аккаунт». Оформление -
// как у «Возврата»: крошки, заголовок, карточки, шаги.
export function AccountDeletionPage() {
  const $ = _c(74);
  const {
    t
  } = useTranslation();
  let cards;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== t) {
    const steps = t("accountDeletion.page.steps", {
      returnObjects: true
    }) as unknown as string[];
    const t7 = t("accountDeletion.page.removedTitle");
    const t8 = t("accountDeletion.removed");
    let t9;
    if ($[9] !== t7 || $[10] !== t8) {
      t9 = {
        key: "removed",
        icon: Trash2,
        title: t7,
        text: t8
      };
      $[9] = t7;
      $[10] = t8;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    const t10 = t("accountDeletion.page.keptTitle");
    const t11 = t("accountDeletion.page.keptText");
    let t12;
    if ($[12] !== t10 || $[13] !== t11) {
      t12 = {
        key: "kept",
        icon: ShieldCheck,
        title: t10,
        text: t11
      };
      $[12] = t10;
      $[13] = t11;
      $[14] = t12;
    } else {
      t12 = $[14];
    }
    const t13 = t("accountDeletion.page.blockedTitle");
    const t14 = t("accountDeletion.page.blockedText");
    let t15;
    if ($[15] !== t13 || $[16] !== t14) {
      t15 = {
        key: "blocked",
        icon: Ban,
        title: t13,
        text: t14
      };
      $[15] = t13;
      $[16] = t14;
      $[17] = t15;
    } else {
      t15 = $[17];
    }
    let t16;
    if ($[18] !== t12 || $[19] !== t15 || $[20] !== t9) {
      t16 = [t9, t12, t15];
      $[18] = t12;
      $[19] = t15;
      $[20] = t9;
      $[21] = t16;
    } else {
      t16 = $[21];
    }
    cards = t16;
    t4 = "flex flex-col gap-8";
    t5 = "account-deletion-page";
    const t17 = t("catalog.breadcrumbHome", {
      defaultValue: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F"
    });
    let t18;
    if ($[22] !== t17) {
      t18 = <Link to="/" className="hover:text-osmix-tangelo">{t17}</Link>;
      $[22] = t17;
      $[23] = t18;
    } else {
      t18 = $[23];
    }
    const t19 = t("accountDeletion.page.title");
    let t20;
    if ($[24] !== t19) {
      t20 = <span className="text-[#1F1F1F]">{t19}</span>;
      $[24] = t19;
      $[25] = t20;
    } else {
      t20 = $[25];
    }
    let t21;
    if ($[26] !== t18 || $[27] !== t20) {
      t21 = <nav aria-label={"\u0425\u043B\u0435\u0431\u043D\u044B\u0435 \u043A\u0440\u043E\u0448\u043A\u0438"} className="flex flex-wrap items-center gap-3 text-[14px] leading-[18px] text-black/50">{t18}{t20}</nav>;
      $[26] = t18;
      $[27] = t20;
      $[28] = t21;
    } else {
      t21 = $[28];
    }
    const t22 = t("accountDeletion.page.title");
    let t23;
    if ($[29] !== t22) {
      t23 = <h1 className="type-h1-bold">{t22}</h1>;
      $[29] = t22;
      $[30] = t23;
    } else {
      t23 = $[30];
    }
    const t24 = t("accountDeletion.page.intro");
    let t25;
    if ($[31] !== t24) {
      t25 = <p className="max-w-2xl type-body1 text-osmix-text-2">{t24}</p>;
      $[31] = t24;
      $[32] = t25;
    } else {
      t25 = $[32];
    }
    let t26;
    if ($[33] !== t23 || $[34] !== t25) {
      t26 = <div className="flex flex-col gap-2">{t23}{t25}</div>;
      $[33] = t23;
      $[34] = t25;
      $[35] = t26;
    } else {
      t26 = $[35];
    }
    if ($[36] !== t21 || $[37] !== t26) {
      t6 = <div className="flex flex-col gap-6">{t21}{t26}</div>;
      $[36] = t21;
      $[37] = t26;
      $[38] = t6;
    } else {
      t6 = $[38];
    }
    t2 = "flex flex-col gap-4";
    const t27 = t("accountDeletion.page.stepsTitle");
    if ($[39] !== t27) {
      t3 = <h2 className="type-h2">{t27}</h2>;
      $[39] = t27;
      $[40] = t3;
    } else {
      t3 = $[40];
    }
    t0 = "flex max-w-3xl flex-col gap-3";
    t1 = (Array.isArray(steps) ? steps : []).map(_temp);
    $[0] = t;
    $[1] = cards;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    cards = $[1];
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[41] !== t0 || $[42] !== t1) {
    t7 = <ol className={t0}>{t1}</ol>;
    $[41] = t0;
    $[42] = t1;
    $[43] = t7;
  } else {
    t7 = $[43];
  }
  let t8;
  if ($[44] !== t) {
    t8 = t("accountDeletion.page.toProfile");
    $[44] = t;
    $[45] = t8;
  } else {
    t8 = $[45];
  }
  let t9;
  if ($[46] !== t8) {
    t9 = <Link to="/profile/personal" className="w-fit type-body1 text-osmix-tangelo hover:underline">{t8}</Link>;
    $[46] = t8;
    $[47] = t9;
  } else {
    t9 = $[47];
  }
  let t10;
  if ($[48] !== t2 || $[49] !== t3 || $[50] !== t7 || $[51] !== t9) {
    t10 = <section className={t2}>{t3}{t7}{t9}</section>;
    $[48] = t2;
    $[49] = t3;
    $[50] = t7;
    $[51] = t9;
    $[52] = t10;
  } else {
    t10 = $[52];
  }
  let t11;
  if ($[53] !== cards) {
    t11 = <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{cards.map(_temp2)}</div>;
    $[53] = cards;
    $[54] = t11;
  } else {
    t11 = $[54];
  }
  let t12;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Mail className="size-6 shrink-0 text-osmix-tangelo" strokeWidth={1.5} />;
    $[55] = t12;
  } else {
    t12 = $[55];
  }
  let t13;
  if ($[56] !== t) {
    t13 = t("accountDeletion.page.noAccessTitle");
    $[56] = t;
    $[57] = t13;
  } else {
    t13 = $[57];
  }
  let t14;
  if ($[58] !== t13) {
    t14 = <h2 className="type-body1-bold text-osmix-text-1">{t13}</h2>;
    $[58] = t13;
    $[59] = t14;
  } else {
    t14 = $[59];
  }
  let t15;
  if ($[60] !== t) {
    t15 = t("accountDeletion.page.noAccessText", {
      email: OPERATOR.privacyEmail
    });
    $[60] = t;
    $[61] = t15;
  } else {
    t15 = $[61];
  }
  let t16;
  if ($[62] !== t15) {
    t16 = <p className="type-body2 text-osmix-text-2">{t15}</p>;
    $[62] = t15;
    $[63] = t16;
  } else {
    t16 = $[63];
  }
  let t17;
  if ($[64] !== t14 || $[65] !== t16) {
    t17 = <section className="flex gap-3 rounded-[16px] bg-osmix-tangelo/5 p-5">{t12}<div className="flex flex-col gap-2">{t14}{t16}</div></section>;
    $[64] = t14;
    $[65] = t16;
    $[66] = t17;
  } else {
    t17 = $[66];
  }
  let t18;
  if ($[67] !== t10 || $[68] !== t11 || $[69] !== t17 || $[70] !== t4 || $[71] !== t5 || $[72] !== t6) {
    t18 = <div className={t4} data-testid={t5}>{t6}{t10}{t11}{t17}</div>;
    $[67] = t10;
    $[68] = t11;
    $[69] = t17;
    $[70] = t4;
    $[71] = t5;
    $[72] = t6;
    $[73] = t18;
  } else {
    t18 = $[73];
  }
  return t18;
}
function _temp2(c) {
  return <section key={c.key} className="flex flex-col gap-3 rounded-[16px] bg-[#F8F8F8] p-5"><span className="flex size-11 items-center justify-center rounded-[12px] bg-white text-osmix-tangelo"><c.icon className="size-6" strokeWidth={1.5} /></span><h2 className="type-h5 text-osmix-text-1">{c.title}</h2><p className="type-body2 text-osmix-text-2">{c.text}</p></section>;
}
function _temp(step, i) {
  return <li key={step} className="flex gap-3 type-body1 text-osmix-text-1"><span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-osmix-tangelo/10 type-body2 font-semibold text-osmix-tangelo">{i + 1}</span><span className="pt-0.5">{step}</span></li>;
}